import { Grid } from '@material-ui/core';
import React from 'react';

import { saveAnalysis, updateAnalysis } from 'api/hs/definitions/health-definitions/analysis';
import BaseDefinitionForm from 'Common/BaseDefinitionForm';
import TextField from 'Common/Form/TextField';
import { AnalysisModel } from 'model/definitions/health-definitions/analysis.model';

interface Props {
  open: boolean;

  /**
   * Fires when the dialog is wanted to be closed
   * @param success `true` when the allergy is created/updated
   */
  onClose(success: boolean): void;

  data: AnalysisModel;
}

export default function Analysis({ open, onClose, data }: Props) {
  return (
    <BaseDefinitionForm<AnalysisModel>
      open={open}
      onClose={onClose}
      onSave={saveAnalysis}
      onUpdate={updateAnalysis}
      data={data}
      createTitle="Tahlil / Tetkik Ekleme"
      updateTitle="Tathil / Tetkik Düzenleme"
      maxDialogWidth={500}>
      <Grid item lg={12} md={12}>
        <TextField required name="label" label="Tahlil Adı Giriniz" />
      </Grid>
    </BaseDefinitionForm>
  );
}
